import React from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Card from 'react-bootstrap/Card';
import { Link } from 'react-router-dom';
import { useState } from 'react';
function EmployerSignUpAccountSecurity() {
    const [validated, setValidated] = useState(false);

    const handleSubmit = (event) => {
      const form = event.currentTarget;
      if (form.checkValidity() === false) {
        event.preventDefault();
        event.stopPropagation();
      }
  
      setValidated(true);
    };
  
    return (
    <Container fluid className='m-0 p-0' >
       <div style={{ backgroundColor: '#025EA9' }} className='m-0 p-4 header-bg text-center'>
                <Container>
                    <h2 class="text-white pt-3">Sign Up</h2>
                </Container>
            </div>
   
        <Container className='p-4'>
      
        <Row>
        <Col sm={3} className='progressbar-bg'>
        <ul class="StepProgress">
    <li class="StepProgress-item is-done">Company Details</li>
    <li class="StepProgress-item is-done">Industry Focus</li>
    <li class="StepProgress-item is-done">Contact Person Details</li>
    <li class="StepProgress-item is-done">Account Security</li>
    <li class="StepProgress-item"> Preview and Submit</li>
      </ul>
        </Col>
        <Col sm={5} style={{margin:'auto'}}>        
    <h6 style={{color:'#025EA9'}}>Employeer</h6>
    <Container className='m-auto'>   
    <Form noValidate validated={validated} onSubmit={handleSubmit}>      
        <Row>
        <Card className='rounded p-4' style={{backgroundColor:'#EBF2F7', border:'1px solid #025EA9'}}> 
        <h6>Account Security</h6>
        <Col sm={12} >
        <Form.Group className="mb-2" controlId="">
        <Form.Label className='label'>Set Password *</Form.Label>
        <Form.Control type="password" className='form-input'placeholder="Enter New Password" required />
        <Form.Control.Feedback type="invalid">
        Required Field
          </Form.Control.Feedback>
      </Form.Group>
            </Col>
            <Col sm={12} >
        <Form.Group className="mb-2" controlId="">
        <Form.Label className='label'>Confirm Password *</Form.Label>
        <Form.Control type="password" className='form-input'placeholder="Enter Confirm Password " required />
        <Form.Control.Feedback type="invalid">
        Required Field
          </Form.Control.Feedback>
      </Form.Group>
            </Col>       
           
             
                  
         </Card>
         
         </Row>
        <Row>
        <Col className='text-center mt-4'>
        <Card.Link  as={Link} to="/EmployerSignUpContactPersonDetails" className='mr-4 pr-4'><i class="bi bi-arrow-left"></i> Back  </Card.Link> 
        <Button type="submit" className='rounded-button ml-2'> Save and continue <i class="bi bi-arrow-right"></i></Button>
        </Col>
        </Row>
       </Form>
       </Container>
       </Col>
    </Row>
      </Container>

    

     
    </Container>

  );


}

export default EmployerSignUpAccountSecurity